// Code review - In Progress
// Documentation - In Progress
import axios from "axios";
let BASE_URL = window.location.origin;
if (process.env.NODE_ENV === "development") {
  // BASE_URL = "http://localhost:5154";  // Uncomment this line if you want to use a different base URL in development
  BASE_URL = "http://test.ethosflo.com/api";
}
else {
  BASE_URL = `${BASE_URL}/api`;
}
const IUDAPI = async (payload, apiCall) => {
  var token = localStorage.getItem("jwtToken");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
  const response = await axios.post(
    // `http://ethosflo-nfp.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-dev.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-test.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-uat.xlicon.com/api/${apiCall}`,
    // `http://localhost:5154/${apiCall}`,
    // `http://ethosflo.com/api/${apiCall}`,
    // `https://ethosflo.com/api/${apiCall}`,
    // `http://uat.ethosflo.com/api/${apiCall}`,
    // `http://test.ethosflo.com/api/${apiCall}`,
    `${BASE_URL}/${apiCall}`,

    payload,
    { headers }
  );
  return response;
};
const LoginAPI = async (payload, apiCall) => {
  try {
    const token = localStorage.getItem("jwtToken");

    if (!token) {
      throw new Error("JWT token not found.");
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    // Replace with actual production URL once deployed
    const response = await axios.post(
      // `http://ethosflo-nfp.xlicon.com/api/${apiCall}`,
      // `http://ethosflo-dev.xlicon.com/api/${apiCall}`,
      // `http://ethosflo-test.xlicon.com/api/${apiCall}`,
      // `http://ethosflo-uat.xlicon.com/api/${apiCall}`,
      // `http://localhost:5154/${apiCall}`,
      // `http://ethosflo.com/api/${apiCall}`,
      // `https://ethosflo.com/api/${apiCall}`,
      // `http://uat.ethosflo.com/api/${apiCall}`,
      // `http://test.ethosflo.com/api/${apiCall}`,
      `${BASE_URL}/${apiCall}`,
      payload,
      { headers }
    );

    return response.data; // Assuming you want to return the response body
  } catch (error) {
    console.error("API Request Error:", error);
    // You can handle different types of errors accordingly
    // For example, if the token is invalid or expired, handle it specifically
    if (error.response && error.response.status === 401) {
      // Token might be expired or invalid
      console.error("Unauthorized access - Token might be expired.");
    } else {
      console.error("An error occurred during the API request.");
    }
    throw error; // Re-throw error so it can be handled in the calling function
  }
};
const BindAPI = async (apiCall) => {
  var token = localStorage.getItem("jwtToken");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
  const response = await axios.get(
    // `http://ethosflo-nfp.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-dev.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-test.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-uat.xlicon.com/api/${apiCall}`,
    // `http://localhost:5154/${apiCall}`,
    // `http://ethosflo.com/api/${apiCall}`,
    // `https://ethosflo.com/api/${apiCall}`,
    // `http://uat.ethosflo.com/api/${apiCall}`,
    // `http://test.ethosflo.com/api/${apiCall}`,
    `${BASE_URL}/${apiCall}`,


    { headers }
  );
  return response;
};

const BindPostAPI = async (Binddata, apiCall) => {
  var token = localStorage.getItem("jwtToken");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const response = await axios.post(
    // `http://ethosflo-nfp.xlicon.com/api/${apiCall}`,
    //  `http://ethosflo-dev.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-test.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-uat.xlicon.com/api/${apiCall}`,
    // `http://localhost:5154/${apiCall}`,
    // `http://ethosflo.com/api/${apiCall}`,
    // `https://ethosflo.com/api/${apiCall}`,
    // `http://uat.ethosflo.com/api/${apiCall}`,
    // `http://test.ethosflo.com/api/${apiCall}`,
    `${BASE_URL}/${apiCall}`,
    Binddata,
    { headers }
  );
  return response;
};

const ImageAPI = async (imagePayload, apiCall) => {
  var token = localStorage.getItem("jwtToken");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
  };
  const Imageresponse = await axios.post(
    // `http://ethosflo-nfp.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-dev.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-test.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-uat.xlicon.com/api/${apiCall}`,
    // `http://localhost:5154/${apiCall}`,
    // `http://ethosflo.com/api/${apiCall}`,
    // `https://ethosflo.com/api/${apiCall}`,
    // `http://uat.ethosflo.com/api/${apiCall}`,
    // `http://test.ethosflo.com/api/${apiCall}`,
    `${BASE_URL}/${apiCall}`,
    imagePayload,
    { headers }
  );

  return Imageresponse;
};
const JSONAPI = async (payload, apiCall, method = "POST") => {
  var token = localStorage.getItem("jwtToken");
  return axios({
    url:
      // `http://ethosflo-nfp.xlicon.com/api/${apiCall}`,
      //  `http://ethosflo-dev.xlicon.com/api/${apiCall}`,
      // `http://ethosflo-test.xlicon.com/api/${apiCall}`,
      // `http://ethosflo-uat.xlicon.com/api/${apiCall}`,
      // `http://localhost:5154/${apiCall}`,
      // `http://ethosflo.com/api/${apiCall}`,
      // `https://ethosflo.com/api/${apiCall}`,
      // `http://uat.ethosflo.com/api/${apiCall}`,
      // `http://test.ethosflo.com/api/${apiCall}`,
      `${BASE_URL}/${apiCall}`,
    method,
    data: payload,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

const authenticationAPI = async (payload, apiCall) => {
  const response = await axios.post(
    // `http://ethosflo-nfp.xlicon.com/api/${apiCall}`,
    //  `http://ethosflo-dev.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-test.xlicon.com/api/${apiCall}`,
    // `http://ethosflo-uat.xlicon.com/api/${apiCall}`,
    // `http://localhost:5154/${apiCall}`,
    // `http://ethosflo.com/api/${apiCall}`,
    // `https://ethosflo.com/api/${apiCall}`,
    // `http://uat.ethosflo.com/api/${apiCall}`,
    // `http://test.ethosflo.com/api/${apiCall}`,
    `${BASE_URL}/${apiCall}`,

    payload
  );
  return response;
};

export { IUDAPI, LoginAPI, BindAPI, ImageAPI, BindPostAPI, authenticationAPI, JSONAPI };
